import React, { useRef, useState, useEffect } from "react";
import "./Graphs.css";
import Linechart from "../../components/graphs/Linechart.jsx";
import Groupedchart from "../../components/graphs/Groupedchart.jsx";
import PieChart from "../../components/graphs/PieChart.jsx";
import Bubblechart2 from "../../components/graphs/Bubblechart2.jsx";
import Rankings from "../../components/graphs/Rankings.jsx";
import { GraphInfoPopup } from "../../components/GraphInfoPopup";
import { useAppSelector } from "../../redux";
import { formatTime } from "../../utils/utils";

const graphs = [
  {
    title: "Electric, Steam, and Chilled Water by Building",
    description: "TBD",
    descriptionForPopup:
      "All data has been normalized to be in kilowatt hours (kWh). The chilled water measurement has been scaled down for readability on this scale.",
    thumbnail: "/img/bargraph.png",
  },
  {
    title: "Electric by Building",
    description: "Current Rankings of Biggest-Smallest Energy Consumers",
    descriptionForPopup:
      "A single kilowatt (kWh) hour is the amount of energy it takes to run a 1,000 watt appliance for one hour.",

    thumbnail: "/img/horizontal.png",
  },
  {
    title: "Steam by Building",
    description:
      "Measuring in pounds of steam per building over time. This steam, produced by the co-generation plant, is used for heating, although the plant also uses steam to produce electricity.",
    descriptionForPopup:
      "Some of the steam produced by the co-generation plant travels around campus through a network of underground pipes to provide buildings with heat.",
    thumbnail: "/img/linesteam.png",
  },
  {
    title: "Chilled Water by Building",
    description:
      "Apart from usual uses, more buildings on campus are using cool water as a temperature modulator.",
    descriptionForPopup:
      "Apart from usual uses, more buildings on campus are using cool water as a temperature modulator.",

    thumbnail: "/img/bubblewater.png",
  },
  {
    title: "Electric versus Solar",
    description: "A Piechart Comparison",
    descriptionForPopup:
      "Shown in solar produced on campus and electricity purchased from the grid.",

    thumbnail: "/img/piechart.png",
  },
];

function GraphComponent(
  graphInd: number,
  { width, height }: { width: number; height: number }
) {
  const components = [
    <Groupedchart key="grouped-chart" width={width} height={height} />,
    <Rankings key="rankings" width={width} height={height} />,
    <Linechart key="line-chart" width={width} height={height} />,
    <Bubblechart2 key="bubble-chart-2" width={width} height={height} />,
    <PieChart key="pie-chart" width={width} height={height} />,
  ];
  return components[graphInd];
}

export const GraphsScreen: React.FC = () => {
  const lastUpdated = useAppSelector(
    (state: any) => state.electric.lastUpdated
  );

  const [selectedGraph, setSelectedGraph] = useState(0);
  const [graphForPopup, setGraphForPopup] = useState<string | null>(null);
  const graphContainerRef = useRef<HTMLDivElement>(null);

  // New state variables for width and height
  const [graphWidth, setGraphWidth] = useState(0);
  const [graphHeight, setGraphHeight] = useState(0);

  const closePopup = () => {
    setGraphForPopup(null);
  };

  const updateDimensions = () => {
    if (graphContainerRef.current) {
      setGraphWidth(
        graphContainerRef.current.getBoundingClientRect().width - 100
      );
      setGraphHeight(
        graphContainerRef.current.getBoundingClientRect().height - 100
      );
    }
  };

  useEffect(() => {
    updateDimensions(); // Initial call

    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);

  useEffect(() => {
    // Update dimensions when selectedGraph changes
    updateDimensions();
  }, [selectedGraph]);

  return (
    <div
      className="expand"
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
      }}
    >
      <div className="title-nonabs-container">
        <div className="title-container">
          <div className="title">Campus Energy Data</div>
          <small style={{ fontSize: "16px" }}>
            <span style={{ color: "#00693E", fontSize: "19px" }}>
              {graphs[selectedGraph].title}
            </span>
            :{" "}
            <span style={{ fontWeight: 300 }}>
              {graphs[selectedGraph].descriptionForPopup}
            </span>
          </small>
        </div>
      </div>
      <div className="container">
        <div className="graphContainer">
          <div className="graph" ref={graphContainerRef}>
            {/* Optional: Information button or other elements */}
            {graphWidth > 0 &&
              graphHeight > 0 &&
              GraphComponent(selectedGraph, {
                width: graphWidth,
                height: graphHeight,
              })}
            <span
              style={{
                position: "absolute",
                top: "10px",
                right: "50px",
                fontSize: "14px",
                fontStyle: "italic",
              }}
            >
              Last Updated: {formatTime(lastUpdated)}
            </span>
          </div>
        </div>
        <div className="buttonContainer">
          {graphs.map((graph, index) => (
            <div
              className={`graphButton ${
                index === selectedGraph ? "selected" : ""
              }`}
              onClick={() => setSelectedGraph(index)}
              key={graph.title}
            >
              <div className="buttonTextContainer">
                <div className="graphtitle">{graph.title}</div>
              </div>
              <img className="image" src={graph.thumbnail} alt={graph.title} />
            </div>
          ))}
        </div>
      </div>
      <GraphInfoPopup
        selectedGraphCode={graphForPopup}
        closePopup={closePopup}
      />
    </div>
  );
};
